<table>
  <thead>
    <tr>
      <th class="subtable icon"></th>
      <th class="subtable icon"></th>
      <th class="subtable id sortable" (click)="toOrderBy('1')" [appSort]="listaCultivosFinca" data-order="desc" data-name="id">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.id' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('1')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('2')" [appSort]="listaCultivosFinca" data-order="desc" data-name="codigoGsv">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.codigoGsv' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('2')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('3')" [appSort]="listaCultivosFinca" data-order="desc" data-name="anyoCampanya">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.campanya' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('3')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('4')" [appSort]="listaCultivosFinca" data-order="desc" data-name="desDenominacionCampanya">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.denominacion' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('4')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('5')" [appSort]="listaCultivosFinca" data-order="desc" data-name="superficie">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.superfice' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('5')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('6')" [appSort]="listaCultivosFinca" data-order="desc" data-name="alturaNivelMar">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.altura' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('6')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('7')" [appSort]="listaCultivosFinca" data-order="desc" data-name="nPlantas">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.plantas' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('7')"></i>
        </div>
      </th>
      <th class="subtable string sortable" (click)="toOrderBy('8')" [appSort]="listaCultivosFinca" data-order="desc" data-name="aforo">
        {{'mantenimientoCultivos.tabs.cultivos.cultivoFinca.table.aforo' | translate}}
        <div class="sortable-icons">
          <i [ngClass]="getIcon('8')"></i>
        </div>
      </th>
      <th class="subtable multi-actions-subtable">
        <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('CUL_Ins')"
          (click)="create()" title="{{'mantenimientoCultivos.tabs.cultivos.tituloNew' | translate}}"></i>
      </th>
    </tr>
  </thead>
  <tbody *ngFor="let cultivoFinca of listaCultivosFinca; let i = index; trackBy: trackByCultivoFincaId">
    <tr (click)="showMoreInfo(i)" [ngClass]="{'dropdownInfo': blockchainInfo === i}" [ngStyle]="{'cursor': ((cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) ? 'pointer' : ((cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.role === 'Administrador' ? 'pointer' : 'auto')}">
      <td class="icon">
        <i
          *ngIf="((cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || ((cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.role === 'Administrador')"
          [ngClass]="blockchainInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
          title="{{blockchainInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
      </td>
      <td class="icon">
        <a *ngIf="((cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || ((cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.role === 'Administrador')" href="{{cultivoFinca.cultivoVechain?.txIdExplore}}" target="_blank">
          <i class="fas fa-circle-nodes" title="{{'global.blockchain.verBlockchain' | translate}}" style="cursor: pointer;"></i>
        </a>
      </td>
      <td class="id">{{cultivoFinca.id}}</td>
      <td class="string" style="max-width:170px">{{cultivoFinca.codigoGsv}}</td>
      <td class="string">{{cultivoFinca.anyoCampanya}}</td>
      <td class="string">{{cultivoFinca.desDenominacionCampanya}}</td>
      <td class="string">{{cultivoFinca.superficie | number : '1.0-2' : defaultLanguage}}</td>
      <td class="string">{{cultivoFinca.alturaNivelMar}}</td>
      <td class="string">{{cultivoFinca.nPlantas}}</td>
      <td class="string">{{cultivoFinca.aforo | number : '1.2-2': defaultLanguage}}</td>
      <td class="multi-actions-bigSubtable">
        <i class="fas fa-stream" *ngIf="this.role === 'Administrador' || this.claims.includes('D_MCV_CultivoDet')"
            app-click-stop-propagation (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
        <i class="fa-xl icon-draw-polygon-edit" *ngIf="cultivoFinca.tieneGeo && (this.role === 'Administrador' || this.claims.includes('D_MCV_CultivoGeoUpd'))"
            [ngClass]="{'disabled': (!cultivoFinca.registroEditable)}" title="{{'titles.editarGeometria' | translate}}" app-click-stop-propagation (click)="openAppEdicion(cultivoFinca)"></i>
        <i class="fa-xl icon-draw-polygon-new" *ngIf="!cultivoFinca.tieneGeo && (this.role === 'Administrador' || this.claims.includes('D_MCV_CultivoGeoIns'))"
            [ngClass]="{'disabled': (!cultivoFinca.registroEditable)}" title="{{'titles.addGeometria' | translate}}" app-click-stop-propagation (click)="openAppEdicion(cultivoFinca)"></i>
        <i class="fas fa-handshake" *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Ins')"
            app-click-stop-propagation [ngClass]="{'disabled': (!cultivoFinca.campanyaHabilitada)}" (click)="designarCultivo(cultivoFinca)" title="{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.title' | translate }}"></i>
        <i class="fas fa-pencil-alt" app-click-stop-propagation *ngIf="this.role === 'Administrador' || this.claims.includes('CUL_Upd')"
            [ngClass]="{'disabled': (!cultivoFinca.registroEditable)}" (click)="update(cultivoFinca)" title="{{'titles.editar' | translate}}"></i>
        <i class="far fa-trash-alt" app-click-stop-propagation *ngIf="this.role === 'Administrador' || this.claims.includes('CUL_Del')"
            [ngClass]="{'disabled': (cultivoFinca.registroEnUso)}" (click)="askDelete(cultivoFinca)" title="{{'titles.eliminar' | translate}}"></i>
      </td>
    </tr>
    <tr *ngIf="dropdownSection === i">
      <td colspan="11">
        <section class="tabs">
          <ul>
            <li *ngIf="this.role === 'Administrador' || this.claims.includes('CUL_PROD_List')" [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showCultivosProductor(i)">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.titulo' | translate}}</li>
            <li *ngIf="paisId === 1 && (this.role === 'Administrador' || this.claims.includes('CAT_List'))" [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showCultivosParcela(i)">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoCatastro.titulo' | translate}}</li>
            <li *ngIf="this.role === 'Administrador' || this.claims.includes('CULMAR_List')" [ngClass]="{'active': pestanaActiva[i] === 3}" (click)="showCultivosMarca(i)">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoMarca.titulo' | translate}}</li>
          </ul>
          <content>
            <app-cultivo-productor *ngIf="pestanaActiva[i] === 1" [productoresCultivo]="cultivoFinca.id"
              [paisId]="cultivoFinca.paisIdCampanya" [campanyaHabilitada]="cultivoFinca.campanyaHabilitada" [denominacionId]="cultivoFinca.denominacionIdCampanya"
              (refreshCultivo)="refresh($event)" (pushMessage)="pushMessage($event)"></app-cultivo-productor>
            <app-cultivo-catastro *ngIf="pestanaActiva[i] === 2" [campanyaHabilitada]="cultivoFinca.campanyaHabilitada" [catastrosCultivo]="cultivoFinca.id"
              (pushMessage)="pushMessage($event)"></app-cultivo-catastro>
            <app-cultivo-marca *ngIf="pestanaActiva[i] === 3" [marcasCultivo]="cultivoFinca.id" [campanyaHabilitada]="cultivoFinca.campanyaHabilitada"
              [paisId]="cultivoFinca.paisIdCampanya" [denominacionId]="cultivoFinca.denominacionIdCampanya"
              [aforoDisponible]="cultivoFinca.aforoDisponible" (pushMessage)="pushMessage($event)"
              ></app-cultivo-marca>
          </content>
        </section>
      </td>
    </tr>
    <!-- Campos blockchain -->
    <tr *ngIf="(blockchainInfo === i && (cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || (blockchainInfo === i && (cultivoFinca && cultivoFinca.cultivoVechain?.existeRegBlockchain) && this.role === 'Administrador')">
      <td colspan="11">
        <div class="detail">
          <div class="title">{{'global.blockchain.informacion.titulo' | translate}}</div>
          <div class="block-inline">
            <label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
            <p>{{cultivoFinca.cultivoVechain?.blockchain}}</p>
          </div>
          <div class="block-inline gap">
            <label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
            <p>{{cultivoFinca.cultivoVechain?.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
          </div>
          <div class="block-inline gap nowrap">
            <label>{{'global.blockchain.informacion.input' | translate}}</label>
            <p>{{cultivoFinca.cultivoVechain?.textoHash}}</p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
          <div class="block-inline gap nowrap">
            <label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
            <p>{{cultivoFinca.cultivoVechain?.txId}}</p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
          <div class="block-inline gap nowrap">
            <label>{{'global.blockchain.informacion.hash' | translate}}</label>
            <p>{{cultivoFinca.cultivoVechain?.hash}}</p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
          <div class="block-inline">
            <label></label>
            <p></p>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot *ngIf="!listaCultivosFinca || (listaCultivosFinca && listaCultivosFinca.length < 1)">
    <tr>
      <td colspan="11">
        {{'global.noContent' | translate}}
      </td>
    </tr>
  </tfoot>
</table>
<div class="modal" *ngIf="deleteModal">
  <div class="modal-content">
    <header>
      <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
    </header>
    <content>
      <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
    </content>
    <footer>
      <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
      <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="newEditModal">
  <div class="modal-content">
    <header>
      <h4>{{ cultivoFincaId ? ('mantenimientoCultivos.tabs.cultivos.tituloEdit' | translate) :
        ('mantenimientoCultivos.tabs.cultivos.tituloNew' | translate)}}</h4>
    </header>
    <app-cultivo-finca-new-edit [cultivoFincaId]="cultivoFincaId" [fincaId]="fincaId" [desFinca]="desFinca"
      [paisId]="paisId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-cultivo-finca-new-edit>
  </div>
</div>
<div class="modal-map" *ngIf="edicionModal">
  <div class="modal-content">
    <div>
      <i class="fas fa-times" (click)="closeMap()"></i>
    </div>
    <app-map [app]="'CUL'" [open]="open" [codigoGsv]="codigoGsv" [paisId]="paisId" [denominacionId]="denominacionId" [campanyaId]="campanyaId"></app-map>
  </div>
</div>
<div class="modal" *ngIf="newModalDesignacion">
  <div class="modal-content">
    <header>
      <h4>{{ 'mantenimientoCultivos.tabs.cultivos.crearDesingacion.title' | translate }}</h4>
    </header>
    <app-cultivo-designacion [cultivoDesignacion]="cultivoDesignacion" (refresh)="refreshDesignacion($event)"></app-cultivo-designacion>
  </div>
</div>
